import apiClient from '@shared/services/apiClient';
import type { ProcedureWithGroupDto, ServiceGroup, MapProcedureRequest, CreateProcedureRequest } from '../types/procedure';

export const procedureApi = {
  getProcedures: async (serviceGroupId?: number, mappedOnly?: boolean): Promise<ProcedureWithGroupDto[]> => {
    const params = new URLSearchParams();
    if (serviceGroupId) params.set('serviceGroupId', String(serviceGroupId));
    if (mappedOnly) params.set('mappedOnly', 'true');
    const query = params.toString();
    const response = await apiClient.get(`/procedures${query ? `?${query}` : ''}`);
    return response.data;
  },

  getServiceGroups: async (): Promise<ServiceGroup[]> => {
    const response = await apiClient.get('/proceduregroups');
    return response.data;
  },

  mapProcedure: async (request: MapProcedureRequest): Promise<{ mappingId: number }> => {
    const response = await apiClient.post('/procedures/mappings', request);
    return response.data;
  },

  createProcedure: async (request: CreateProcedureRequest): Promise<{ procedureId: number }> => {
    const response = await apiClient.post('/procedures', request);
    return response.data;
  },
};
